"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _css = require("@emotion/css");
var _react = require("react");
var _hooks = require("../../hooks");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = function useStyles() {
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useContext = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext),
    themeColors = _useContext.themeColors;
  var _useStylesUtils = (0, _hooks.useStylesUtils)(),
    pxToRem = _useStylesUtils.pxToRem;
  var ccImageEditorStyle = (0, _react.useMemo)(function () {
    var deviceProps = function deviceProps() {
      if (isMobileView) {
        return {
          height: pxToRem(316),
          width: '100%',
          overflow: 'hidden',
          borderRadius: pxToRem(8)
        };
      }
      return {
        height: pxToRem(232),
        width: pxToRem(424)
      };
    };
    var zoomBtnProps = function zoomBtnProps() {
      return {
        content: '""',
        position: 'absolute',
        width: '100%',
        height: pxToRem(3),
        background: 'currentColor',
        top: '50%',
        left: '50%',
        transformOrigin: 'center center'
      };
    };
    var zoomProps = function zoomProps() {
      return {
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        width: pxToRem(20),
        height: pxToRem(48),
        color: themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main,
        cursor: 'pointer',
        '&::before': _objectSpread(_objectSpread({}, zoomBtnProps()), {}, {
          transform: 'translate(-50%, -50%)'
        })
      };
    };
    var ccImageEditor = (0, _css.css)({
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    });
    var ccImageEditorCrop = (0, _css.css)(_objectSpread({
      position: 'relative'
    }, deviceProps()));
    var ccImageEditorSlider = (0, _css.css)({
      position: 'relative',
      width: '100%',
      textAlign: 'center'
    });
    var ccImageEditorZoomIn = (0, _css.css)(_objectSpread(_objectSpread({}, zoomProps()), {}, {
      right: 0,
      '&::after': _objectSpread(_objectSpread({}, zoomBtnProps()), {}, {
        transform: 'translate(-50%, -50%) rotate(90deg)'
      })
    }));
    var ccImageEditorZoomOut = (0, _css.css)(_objectSpread(_objectSpread({}, zoomProps()), {}, {
      left: 0
    }));
    return {
      ccImageEditor: ccImageEditor,
      ccImageEditorCrop: ccImageEditorCrop,
      ccImageEditorSlider: ccImageEditorSlider,
      ccImageEditorZoomIn: ccImageEditorZoomIn,
      ccImageEditorZoomOut: ccImageEditorZoomOut
    };
  }, [isMobileView, pxToRem, themeColors === null || themeColors === void 0 ? void 0 : themeColors.primary.main]);
  return {
    'cc-ImageEditor': ccImageEditorStyle.ccImageEditor,
    'cc-ImageEditor__crop': ccImageEditorStyle.ccImageEditorCrop,
    'cc-ImageEditor__slider': ccImageEditorStyle.ccImageEditorSlider,
    'cc-ImageEditor__zoom-in': ccImageEditorStyle.ccImageEditorZoomIn,
    'cc-ImageEditor__zoom-out': ccImageEditorStyle.ccImageEditorZoomOut
  };
};
exports.useStyles = useStyles;